import { render, staticRenderFns } from "./ProjectStudentViewLookbackT.vue?vue&type=template&id=fcc64a68&scoped=true&"
import script from "./ProjectStudentViewLookbackT.vue?vue&type=script&lang=ts&"
export * from "./ProjectStudentViewLookbackT.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectStudentViewLookbackT.vue?vue&type=style&index=0&id=fcc64a68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcc64a68",
  null
  
)

export default component.exports